const state = {
  selectedSupplier: {
    name: ''
  }
}
const getters = {
  GET_SUPPLIER_BREADCRUMB_NAME: (state) => `${state.selectedSupplier.name}`
}

const mutations = {
  SELECT_SUPPLIER: (state, { supplierName }) => { state.selectedSupplier.name = supplierName }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/record/suppliers/state/index.js